import { render, staticRenderFns } from "./UsuarioFornecedorConfiguracoesAcessoForm.vue?vue&type=template&id=5fecafcb&scoped=true&lang=html"
import script from "./UsuarioFornecedorConfiguracoesAcessoForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorConfiguracoesAcessoForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorConfiguracoesAcessoForm.vue?vue&type=style&index=0&id=5fecafcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fecafcb",
  null
  
)

export default component.exports